"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var override_service_1 = require("@services/overrides/override-service");
var environment_1 = require("@shared/types/environment");
var source_1 = require("@shared/types/source");
var source_utils_1 = require("@shared/utils/source-utils");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    module.factory('prSourceDataService', [
        '$q',
        '$http',
        'rsEnvironment',
        'pr.API_ROUTES',
        'prOverrideTrigger',
        'pr.navigationService',
        function ($q, $http, env, API_ROUTES, triggerOverrides, navigationService) {
            // cache is currently only used retrieving all sources for a user, i.e. sourceIds is falsy or empty
            var firstLevelCache;
            var configFlags = triggerOverrides({
                event: override_service_1.OVERRIDE_EVENTS.CONFIG_FLAGS,
                sync: true,
                data: {}
            });
            return {
                warmCache: warmCache,
                clearCache: clearCache,
                getUserSources: getUserSources,
                areDataSourcesDisabled: areDataSourcesDisabled,
                // @todo remove these accessors and make all callers point directly to /src/shared
                getSourceType: source_utils_1.getSourceType,
                sourceTypes: source_1.sourceTypeMap
            };
            /**
             * Returns all user sources. This request can take a very long time when
             * users have lots of sources.
             * @param sourceIds
             * @returns IPromise<SourceInfoMap>
             */
            function getUserSources(sourceIds) {
                var useCache = !lodash_1.default.get(sourceIds, 'length');
                if (useCache && firstLevelCache) {
                    return firstLevelCache;
                }
                if (!sourceIds) {
                    sourceIds = [];
                    var mainFieldsetId = triggerOverrides({
                        event: override_service_1.OVERRIDE_EVENTS.SINGLE_FIELDSET,
                        sync: true
                    });
                    if (mainFieldsetId) {
                        sourceIds = [mainFieldsetId];
                        var activeSurveyId = env.get(environment_1.ENV_VARS.ACTIVE_SURVEY_ID);
                        if (activeSurveyId) {
                            sourceIds.push(activeSurveyId);
                        }
                        sourceIds = lodash_1.default.uniq(sourceIds);
                    }
                }
                var requestUserSourcesForIdsPromise = _requestUserSourcesForIds(sourceIds)
                    .then(function (response) {
                    return response.data;
                });
                if (useCache) {
                    firstLevelCache = requestUserSourcesForIdsPromise;
                }
                return requestUserSourcesForIdsPromise;
            }
            function _requestUserSourcesForIds(sourceIds) {
                if (sourceIds === void 0) { sourceIds = []; }
                return $http.get(API_ROUTES.SOURCES, {
                    cache: true,
                    params: {
                        ids: sourceIds
                    }
                });
            }
            function clearCache() {
                firstLevelCache = null;
            }
            /**
             * We need to warm the cache so that the sources
             * are ready when the user loads the sources dropdown menu.
             * Since the menus aren't used for read-only loads,
             * don't warm the cache since it is an expensive call.
             */
            function warmCache() {
                if (!navigationService.isReadOnly) {
                    getUserSources();
                }
            }
            function areDataSourcesDisabled() {
                return !!configFlags.disableDataSource;
            }
        }
    ]);
})(angular_1.module('qualtrics.pr'));
